import { createCrud } from '../../CRUD';
import { TTelehealth } from './types';

export const telehealthBaseModel = createCrud<TTelehealth>(
  'telehealths',
  'Telehealth',
);
